import React from "react";
import { CreateBandingView } from "./CreateBanding.View";

/**
 * Responsible for rendering the create banding view component
 * @returns JSX element
 */
export const CreateBanding: React.FC = (): JSX.Element => {

  return (
    <div
      className="create-banding-landing"
      id="ebt-outputConfig-banding-addBand"
    >
      <CreateBandingView />
    </div>
  );
};
